import { InformationalTooltip } from 'components/InformationalTooltip';
import * as React from 'react';

interface Props {
  label: string;
  children?: React.ReactNode;
  /** Classes to apply to the children container */
  className?: string;
  tooltip?: string;
}

export const Row: React.FC<Props> = (props) => {
  const { label, children, className, tooltip } = props;
  return (
    <div className="border-b border-gray-100 py-4 grid grid-cols-2">
      <div className="flex items-center gap-1">
        <h4 className="text-gray-600">{label}</h4>
        {tooltip && <InformationalTooltip>{tooltip}</InformationalTooltip>}
      </div>
      <h4 className={`text-gray-900 ${className}`}>{children || '-'}</h4>
    </div>
  );
};
